export const REMEMBER_ME = "rememberMe";
export const SESSION_ID = "sessionId";
export const LOGGED_IN = "loggedIn";
export const LOGIN_TOKEN = "loginToken";
export const SINGLE_SIGN_ON_RESPONSE = "singleSignOnResponse";
